import { Product } from '@/interfaces/catalog/Product'
import API from '@/lib/api'

export type ProductParameterInput = {
  parameterId: string
  isRequired: boolean
  parameterValueId: string | null
  rawValue: string | null
}

export const getProductAxisIds = (product: Product): string[] =>
  [...(product.variantAxes ?? [])].sort((a, b) => a.sortOrder - b.sortOrder).map((item) => item.axisId)

export const getProductParameterInputs = (product: Product): ProductParameterInput[] => {
  const descriptiveValues = new Map(
    (product.descriptiveValues ?? []).map((value) => [value.parameterId, value]),
  )

  return [...(product.parameters ?? [])]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map(({ parameterId, isRequired }) => ({
      parameterId,
      isRequired,
      parameterValueId: descriptiveValues.get(parameterId)?.parameterValueId ?? null,
      rawValue: descriptiveValues.get(parameterId)?.rawValue ?? null,
    }))
}

export const saveProductAxes = (productId: string, axisIds: string[]) =>
  API.put(`/api/v2/products/${productId}/variant-axes`, {
    axes: axisIds.map((axisId, index) => ({ axisId, sortOrder: index })),
  })

export const saveProductParameters = (productId: string, parameters: ProductParameterInput[]) =>
  API.put(`/api/v2/products/${productId}/parameters`, {
    parameters: parameters.map((parameter, index) => ({ ...parameter, sortOrder: index })),
  })
